export const getYearsOfExistence = (): number => {

  return new Date().getFullYear() - 2007;

};
